import { useState, useEffect } from "react";

export const useImageExists = (imagePath: string): boolean => {
  const [exists, setExists] = useState<boolean>(false);

  useEffect(() => {
    const checkImage = async () => {
      try {
        const response = await fetch(imagePath, { method: "HEAD" });

        if (response.ok) {
          const contentType = response.headers.get("Content-Type");
          setExists(contentType?.startsWith("image") ?? false);
        } else {
          setExists(false);
        }
      } catch (error) {
        console.error("Error checking image:", error);
        setExists(false);
      }
    };

    checkImage().catch((error) => {
      console.error("Error checking image:", error);
    });
  }, [imagePath]);

  return exists;
};
